/**
 * Risk rating, as an ordinal.
 *
 * A number rather than a letter because the scale is ordered: "is this riskier
 * than that" is the question asked of it, and a code you cannot compare makes
 * every caller re-derive the ordering.
 *
 * Labels are the issuers' own — a fund's published risk rating is a regulatory
 * statement and not ours to reword. What is normalised is punctuation: the same
 * rating arrives as both "Medium to High" and "Medium-High", which is two
 * spellings of one thing rather than two ratings.
 */
export type RiskCode = 1 | 2 | 3 | 4 | 5;

export const RISK: Record<RiskCode, string> = {
    1: 'Low',
    2: 'Low to Medium',
    3: 'Medium',
    4: 'Medium to High',
    5: 'High',
};

export const riskLabel = (code: RiskCode | null | undefined): string | null => (code == null ? null : (RISK[code] ?? null));

export const codeForRisk = (label: string | null | undefined): RiskCode | null => {
    if (!label) return null;
    // "Medium-High", "medium to high" and "Medium To High" are one rating.
    const key = label.toLowerCase().replace(/[\s-]+/g, ' ').replace(/ to /g, ' ').trim();
    const found = (Object.entries(RISK) as [string, string][]).find(
        ([, name]) => name.toLowerCase().replace(/[\s-]+/g, ' ').replace(/ to /g, ' ') === key,
    );
    return found ? (Number(found[0]) as RiskCode) : null;
};
